import { ChangeDetectionStrategy, Component, input, OnDestroy, output } from '@angular/core';
import { CvMarkerAction, CvMarkerType, determineMarkerAction, getCvMarkerUrl, isVerifiedMarker, MapMarkerData } from '../../map-utils';
import { Location } from '../../../../../models/locations-models/location';
import { MatButton } from '@angular/material/button';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { CoordinateHistory } from '../../../../../models/coordinate-history';
import { MatDivider } from '@angular/material/divider';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-cv-info-window-content',
  templateUrl: './cv-info-window-content.component.html',
  styleUrls: ['../../../../../../assets/scss/partials/info-window-close-button.scss',
    './cv-info-window-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButton, NgTemplateOutlet, DatePipe, MatDivider],
})


export class CVInfoWindowContentComponent implements OnDestroy {
  marker = input.required<MapMarkerData>();
  focusedLocation = input.required<Location>();
  validationHistory = input.required<CoordinateHistory[]>();
  lastValidation = input.required<CoordinateHistory>();

  protected readonly processMarkerAction = output<MapMarkerData>();

  protected readonly cvMarkerAction = CvMarkerAction;
  protected readonly cvMarkerType = CvMarkerType;
  protected readonly getCvMarkerUrl = getCvMarkerUrl;
  protected readonly isVerifiedMarker = isVerifiedMarker;
  protected readonly determineMarkerAction = determineMarkerAction;

  private componentDestroyed = new Subject<void>();

  constructor() {
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
  }

  protected getTimestamp(marker: MapMarkerData): string | Date {
    // 1. History Markers
    if (marker.type === CvMarkerType.HISTORY) {
      return this.getHistoryItem(marker.id)?.createdDateTime ?? '';
    }

    // 2. Verified Geocode Marker (The Blue Pin)
    if (isVerifiedMarker(marker.id)) {
      return this.lastValidation().createdDateTime;
    }

    return '';
  }

  /**
   * @param id
   * @private
   */
  protected getHistoryItem(id: string): CoordinateHistory {
    return this.validationHistory()
        .find(vh => String(vh.id) === id);
  }

}
